import React, { memo } from "react";
import { Box } from "@mui/material";

const AppNoDataTable = ({
  title = "Không có dữ liệu!",
}: {
  title?: string;
}) => {
  return (
    <Box className="px-5 py-10 pt-[100px] text-center w-full col-span-full">
      {title}
    </Box>
  );
};

export default memo(AppNoDataTable);
